import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DialogBaseViewComponent } from '@sb/library/base';
import { UploadDialogData } from '../upload.definitions';

@Component({
    selector: 'lib-upload-dialog',
    templateUrl: './upload-dialog.component.html',
    styleUrls: ['./upload-dialog.component.scss']
})
export class DialogUploadComponent extends DialogBaseViewComponent<UploadDialogData> implements OnInit {
    @Output() selectedFiles: EventEmitter<Array<File>> = new EventEmitter();
    protected _files: File[] = [];

    override ngOnInit() {
        super.ngOnInit();
        this.selectedFiles.emit([]);
        this._files = [];
    }

    EmitFiles(files: Array<File>) {
        this.selectedFiles.emit(files);
        this._files = [...files];
    }

    GetNamesAboveMaxSize(): string[] {
        return this._files.filter((file: File) => (!isNaN(file.size) && (file.size > this.data.MaxAllowedFilesize!))).map((file: File) => file.name);
    }

    get hasFiles(): boolean {
        return this._files.length > 0;
    }

    get files(): File[] {
        return this._files;
    }

    get primaryButtonText(): string {
        return this.data.PrimaryButtonText ?? $localize`:@@CommonOKButton:OK`;
    }

    get secondaryButtonText(): string {
        return this.data.SecondaryButtonText ?? $localize`:@@CommonCancelButton:Cancel`;
    }
}
